<template>
    <div style="font-size: 16px;">
        权限角色设置
    </div>
    <div class="riperpo">
        <table>
            <thead>
                <tr>
                    <th style="width: 200px;">管理员角色</th>
                    <th style="width: 400px;">具体权限</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody  v-infinite-scroll="load" :infinite-scroll-immediate="false">
                <tr v-for="(item, index) in Rolelist" :key="index">
                    <td style="width: 200px;">
                        <div>{{ item.roleName }}</div>
                    </td>
                    <td style="width: 400px;">
                        <div v-if="!item.roleDesc">
                            未知
                        </div>
                        <div v-else>
                            <div :title="item.roleDesc" style="width: 330px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ item.roleDesc }}</div>
                        </div>
                    </td>
                    <td>
                        <div @click="xiugai(item.roleId,item.roleName)">修改权限</div>
                        <div @click="handleClose(item.roleId)">删除</div>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import store from '@/api/store';
import { ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
let Rolelist = ref([])
const router = useRouter()
onMounted(() => {
    pageRole()
})
const xiugai = (roleId,roleName)=>{
    router.push({
      path:'/home/install/roleadd',
      query:{
        roleId,
        roleName
      }
   })
}
const handleClose = (id) => {
    ElMessageBox.confirm('是否要删除该角色?')
        .then(() => {
            console.log(222)
            let data = {
                roleId: id
            }
            delerol(data, 2)
        })
        .catch(() => {
            // catch error
            console.log(22333)
        })
}
const delerol = async (data, roleId) => {
    const res = await store.changeRole(data, roleId)
    console.log(res)

    if (res.success) {

        location.reload()
    }
}
const current = ref(1)
const load = async () => {
    console.log(';current', current.value)

    current.value++
    try {
        let data = {
        
            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }
        const res = await store.pageRole(data)
        console.log(res)
        Rolelist.value.push(...res.data.records)
    } catch (error) {
        console.log(error)

    }
}
const pageRole = async () => {
    try {
        const data = {
            
            "page": {
                "current": current.value,
                "pageSize": 6
            }

        }
        const res = await store.pageRole(data)
        Rolelist.value = res.data.records
        console.log(Rolelist.value)
    } catch (error) {
        console.log(error)
    }
}
</script>

<style lang="scss" scoped>
tbody {
    display: block;
}
thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}
.riperpo {
    margin-top: 21px;

    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {

            height: 46px;
            line-height: 46px;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;

            th {
                text-align: left;
                background: #EEEEEE;
                box-sizing: border-box;
            }

            th:first-child {

                width: 200px;
                border-radius: 8px 0 0 8px;
                padding-left: 24px;
                box-sizing: border-box;
            }

            th:last-child {

                border-radius: 0 8px 8px 0;
            }
        }

        tbody {
            width: 100%;
            height: 420px;
            overflow-y: scroll;
            tr {
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                color: #718096;

                td {
                    height: 87px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #E9E9E9;
                    padding-top: 24px;
                    vertical-align: middle;
                    text-align: left;

                }

                td:last-child {
                    font-size: 14px;
                    font-weight: 400;
                    color: #1890FF;

                    div {
                        float: left;
                        cursor: pointer;
                    }

                    div:last-child {
                        margin-left: 33px;
                    }

                }

                td:first-child {
                    padding: 21px 0 0 20px;
                    width: 100px;
                    text-align: left;

                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);

                    div:last-child {
                        margin-top: 6px;
                        color: rgba(0, 0, 0, 0.45);
                        font-weight: 400;
                    }

                }
            }
        }
    }

}
</style>